import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconRadioButton$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRadioButton extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'cc25291c0512fc05a82a1379068d2d4e6ec02ad2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7b351ce2b0d218051d141fc1127485097c07ce42', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5466210ab76eb4e9450899d991ae183b7c49f0ad', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 3.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-radio-button", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-radio-button"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-radio-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRadioButton$1);
            }
            break;
    } });
}

const CosmosIconRadioButton = CosmosIconRadioButton$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRadioButton, defineCustomElement };
